import { render, staticRenderFns } from "./ChangePosition.vue?vue&type=template&id=1c42449a&scoped=true"
import script from "./ChangePosition.vue?vue&type=script&lang=js"
export * from "./ChangePosition.vue?vue&type=script&lang=js"
import style0 from "./ChangePosition.vue?vue&type=style&index=0&id=1c42449a&prod&lang=scss&scoped=true"
import style1 from "./ChangePosition.vue?vue&type=style&index=1&id=1c42449a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42449a",
  null
  
)

export default component.exports